import React, { useRef, useState } from "react";
import { toast } from "sonner";
import api, { API_BASE } from "@/lib/api";
import { Button } from "@/components/ui-kit";
import { FileSpreadsheet, Upload, Download } from "lucide-react";

/**
 * Bulk Excel Import + Template Download button group.
 * Props:
 *  - kind: "prices" | "pos" | "sj" | "stocks"
 *  - onDone: callback to reload data
 */
export default function BulkImport({ kind, onDone }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const downloadTemplate = async () => {
    try {
      const r = await api.get(`/import/template/${kind}`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `template_${kind}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Gagal mengunduh template");
    }
  };

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post(`/import/${kind}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      const sk = r.data.skipped_duplicates || 0;
      const msg = `${r.data.inserted} baris diimpor` + (sk > 0 ? ` · ${sk} duplikat dilewati` : "");
      if (sk > 0) toast.info(msg, { duration: 6000 });
      else toast.success(msg);
      onDone?.();
    } catch (err) {
      toast.error("Gagal impor: " + (err?.response?.data?.detail || "format file tidak sesuai"));
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Button variant="ghost" onClick={downloadTemplate} className="!px-3 !py-1.5 text-xs" data-testid={`bulk-template-${kind}`}>
        <Download className="h-3.5 w-3.5" />Template
      </Button>
      <Button variant="secondary" onClick={() => inputRef.current?.click()} disabled={busy} className="!px-3 !py-1.5 text-xs" data-testid={`bulk-import-${kind}`}>
        <FileSpreadsheet className="h-3.5 w-3.5" />{busy ? "Mengimpor…" : "Import Excel"}
      </Button>
      <input ref={inputRef} type="file" accept=".xlsx,.xls" className="hidden" onChange={onFile} />
    </div>
  );
}
